import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { ISecureInformationRequestTemplate } from './types';

function useSecureInformationRequestTemplates(agentFirmId?: string) {
  const query = new URLSearchParams();
  if (agentFirmId) query.append('agentFirmId', agentFirmId);

  const {
    data,
    error,
    mutate,
  }: {
    data?: {
      secureInformationRequestTemplates: ISecureInformationRequestTemplate[];
    };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `secureInformationRequestTemplate/?${query.toString()}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data,
    error,
    mutate,
  };
}

export { useSecureInformationRequestTemplates };
